// Date utility functions

export function getYears(startYear, endYear) {
    let yearArray = [];

    for (var i = startYear; i <= endYear; i++) {
        let item = {
            name: i,
            value: i
        };

        yearArray.push(item);
    }

    return yearArray;
}

export function getCurrentTimeInSeconds() {
	return Math.round(new Date().getTime() / 1000.0);
}
